import React from 'react';
import { Box, Typography, Alert, AlertTitle, Grid } from '@mui/material';
import { CPEFlagsProps, IFlag } from './types';
import FlagCard from './FlagCard';
import { ActionType } from 'types/action';
import { resolveCpeClaimFlag } from 'context/inspections';

const CPEFlags: React.FC<CPEFlagsProps> = ({ flags, claimDispatch }) => {
  if (!flags?.length) {
    return (
      <Box sx={{ p: 2 }}>
        <Alert severity="info">
          <AlertTitle>No Flags</AlertTitle>
          No flags found
        </Alert>
      </Box>
    );
  }

  const handleResolveFlag = async (flag: IFlag) => {
    try {
      await resolveCpeClaimFlag(flag.claimId, flag.id);

      // Update global claim state only
      claimDispatch({
        type: ActionType.UPDATE_CLAIM_FLAGS,
        payload: flags.map((f) =>
          f.id === flag.id ? { ...f, status: 'resolved' } : f,
        ),
      });
    } catch (error) {
      console.error('Error resolving flag:', error);
    }
  };

  const activeFlags = flags.filter((flag) => flag.status !== 'resolved');
  const resolvedFlags = flags.filter((flag) => flag.status === 'resolved');

  const sortedActiveFlags = [...activeFlags].sort((a, b) => {
    if (a.category === 'BLOCKING' && b.category !== 'BLOCKING') {
      return -1;
    }
    if (a.category !== 'BLOCKING' && b.category === 'BLOCKING') {
      return 1;
    }

    return 0;
  });

  return (
    <Box sx={{ p: 2 }}>
      {activeFlags.length > 0 && (
        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
            Active Flags
          </Typography>
          <Grid container spacing={2}>
            {sortedActiveFlags.map((flag) => (
              <Grid item xs={12} sm={6} md={4} key={flag.id}>
                <FlagCard
                  flag={flag}
                  onResolve={() => handleResolveFlag(flag)}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      )}

      {resolvedFlags.length > 0 && (
        <Box>
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
            Resolved Flags
          </Typography>
          <Grid container spacing={2}>
            {resolvedFlags.map((flag) => (
              <Grid item xs={12} sm={6} md={4} key={flag.id}>
                <FlagCard
                  flag={flag}
                  onResolve={() => handleResolveFlag(flag)}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      )}
    </Box>
  );
};

export default CPEFlags;
